import type { DataRow, DatasetSummary } from "../types";
import { branchForDma } from "./branches";

const areas = ["010305", "010306", "010304", "020101", "020102", "030201", "030202", "040302"];
const statuses = ["เสร็จสิ้น", "กำลังดำเนินการ", "รอสำรวจ", "ยกเลิก"];
const workTypes = ["ท่อแตกรั่ว", "ประตูน้ำ", "มาตรวัดน้ำ", "ตรวจสอบแรงดัน"];
const teams = ["ทีม กปน. 1", "ทีม กปน. 2", "ผู้รับจ้าง A", "ผู้รับจ้าง B"];

export const sampleRows: DataRow[] = Array.from({ length: 84 }, (_, index) => {
  const isRepeat = index < 12;
  const dmaCode = isRepeat ? "010305" : index % 13 === 0 ? null : areas[index % areas.length];
  const branch = branchForDma(dmaCode);
  const latitude = isRepeat ? 13.7500 + (index % 3) * .00008 : index % 11 === 0 ? null : 13.68 + ((index * 17) % 70) / 200;
  const longitude = isRepeat ? 100.5000 + (index % 4) * .00007 : latitude === null ? null : 100.34 + ((index * 29) % 95) / 200;
  const date = isRepeat ? `2026-09-${String(1 + Math.floor(index / 3)).padStart(2, "0")}` : `2026-${String(7 + (index % 3)).padStart(2, "0")}-${String(1 + (index % 27)).padStart(2, "0")}`;
  const hour = isRepeat ? 18 + (index % 3) : 6 + (index * 5) % 18;
  const receivedAt = `${date}T${String(hour).padStart(2, "0")}:${String((index * 7) % 60).padStart(2, "0")}:00+07:00`;
  return {
    __rowId: `sample-${index + 1}`,
    dmaCode,
    branchNumber: branch?.number ?? null,
    branchShortName: branch?.shortName ?? null,
    branchFullName: branch?.fullName ?? null,
    jobId: `LR-${String(26000 + Math.floor(index / (index % 19 === 0 ? 2 : 1))).padStart(6, "0")}`,
    status: statuses[index % statuses.length],
    workType: isRepeat ? "น้ำไหลอ่อน" : workTypes[(index * 3) % workTypes.length],
    team: teams[(index * 5) % teams.length],
    openedAt: receivedAt,
    receivedAt,
    receivedTime: receivedAt.slice(11, 19),
    road: isRepeat ? "ถนนประชาชื่น" : null,
    soi: isRepeat ? "ซอย 12" : null,
    address: null,
    reportedDetail: isRepeat ? "ผู้ใช้น้ำแจ้งน้ำไหลอ่อน บริเวณถนนประชาชื่น ซอย 12" : null,
    workDetail: isRepeat ? "ตรวจสอบแรงดันและสำรวจแนวท่อ" : null,
    latitude,
    longitude,
    cost: index % 9 === 0 ? null : 1200 + ((index * 731) % 18000),
  };
});

export const sampleSummary: DatasetSummary = {
  name: "ข้อมูลสาธิต DMA (ข้อมูลสังเคราะห์)",
  version: "v-demo-2026.10.10",
  versionId: undefined,
  importedAt: "10 ต.ค. 2569 09:30",
  sourceRows: sampleRows.length,
  distinctJobs: new Set(sampleRows.map((row) => row.jobId)).size,
  missingDma: sampleRows.filter((row) => !row.dmaCode).length,
  validCoordinates: sampleRows.filter((row) => row.latitude !== null && row.longitude !== null).length,
  dateFrom: "1 ก.ค. 2569",
  dateTo: "27 ก.ย. 2569",
};


